module.exports = __webpack_public_path__ + "img/MESTNA OBCINA MURSKA SOBOTA.4de95d58.png";